export default __webpack_public_path__ + "static/media/kitchen3-before2-1920w.1f7fcc4c.png";